export const LOGIN = 'admin/login'